import AxiosRequest from './AxiosRequest'

const url = 'jobrun'

/**
 *
 * @param {{stateName?:'SCHEDULED'|'ENQUEUED'|'PROCESSING'|'FAILED'|'SUCCEEDED'|'DELETED',page?:number,size?:number}} params
 * @returns {Promise<{ total:number,offset:number,limit:number,items:Array,currentPage:number,totalPages:number }>} 分页数据
 */
export const getJobs = (params) => {
    return AxiosRequest.get(`${url}/jobs`, { params })
}

export const job = (id) => {
    return AxiosRequest.get(`${url}/jobs/${id}`)
}

export const servers = () => {
    return AxiosRequest.get(`${url}/servers`)
}

export const getStats = () => {
    return AxiosRequest.get(`${url}/stats`)
}
